import { useDebouncedProp } from '@anton.bobrov/react-hooks';
import { useEffect, useState } from 'react';
export function useStates(_a) {
    var isActiveProp = _a.isActive, durationProp = _a.duration, isContentRenderedProp = _a.isContentRendered;
    var _b = useState(isContentRenderedProp), isContentRendered = _b[0], setIsContentRendered = _b[1];
    var _c = useState(isActiveProp), isFirstExpand = _c[0], setIsFirstExpand = _c[1];
    var duration = isFirstExpand ? 1 : durationProp;
    useEffect(function () {
        if (isActiveProp && !isContentRendered) {
            setIsContentRendered(true);
        }
    }, [isActiveProp, isContentRendered]);
    var isActive = useDebouncedProp(isActiveProp, 1);
    return {
        isActive: isActive,
        setIsFirstExpand: setIsFirstExpand,
        isContentRendered: isContentRendered,
        duration: duration,
    };
}
//# sourceMappingURL=useStates.js.map